export enum Agency {
  WFP = 10,
  UNHCR = 20,
}
